import React from 'react';
import './card.css'
const Card = ({ Title, logo1, logo2,col ,count,text = "" }) => {
  return (
    <div className={`col-md-${col} info-card-container` }>
     <div className="image_box">
        <div className="content_box">
            <div className="dot_title">
                <img src={logo1} alt="dot" className="dot" />
                <p className="ps-2">{Title}</p>
            </div>
            <h2 className="mt-2" style={{fontSize:'16px',fontWeight:'700'}}>{`${count} ${text} `}</h2> 
        </div>
        {
          logo2 && 
          <div className="img_icon">
            <img src={logo2} alt="" />
        </div>

        }
        
     </div>
   </div>
  );
};

export default Card;